import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Thread from './Thread';
import { CurrentUserContext } from 'contexts/CurrentUserContext'
import { WritingModeProvider, useWritingMode } from 'contexts/WritingModeContext'
import MainNav from './MainNav';

import MyLists from './MyLists';
import NewList from './NewList';
import List from './List';
import ListAsGraph from './ListAsGraph';
import Comparison from './Comparison';
import OnboardingSurvey from './OnboardingSurvey';

function Home() {
  return (
    <>
      <Alert variant="success">
        <Alert.Heading>Bootstrap is working!</Alert.Heading>
        <p>
          This is a <strong>Bootstrap alert</strong> rendered with <code>react-bootstrap</code>.
        </p>
      </Alert>
      <Button variant="primary">Click me</Button>
    </>
  );
}

function About() {
  return (
    <>
      <h2>About Page</h2>
      <p>This is the about page of the React SPA.</p>
    </>
  );
}

function AppShell() {
  const { writingMode } = useWritingMode()

  return (
    <>
      {!writingMode && <MainNav/>}
      <div
        className={writingMode ? undefined : 'container mt-4'}
        style={writingMode ? undefined : { maxWidth: '800px' }}
      >
        <Routes>
          <Route path='/onboarding' element={<OnboardingSurvey />} />
          <Route path='/lists' element={<MyLists />} />
          <Route path='/lists/new' element={<NewList />} />
          <Route path='/lists/:id' element={<List />} />
          <Route path='/lists/:list_id/comparisons/:comparison_id' element={<Comparison />} />
          <Route path='/lists/:listId/graph' element={<ListAsGraph />} />
          <Route path="/about" element={<About />} />
          <Route path="/threads/:thread_id" element={<Thread />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </>
  )
}

export default function App() {
  return (
    <CurrentUserContext.Provider value={window.currentUser}>
      <WritingModeProvider>
        <AppShell />
      </WritingModeProvider>
    </CurrentUserContext.Provider>
  );
} 
